import { countryOfOriginChange } from 'app/services/businessFunctions/helpers/countryOfOriginChange';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const ownerCountryOfOrigin = {
  checkoutOwnerCountryOfOriginChange() {
    countryOfOriginChange(
      FieldsEnum.OwnerCountryOfOrigin,
      FieldsEnum.OwnerPassport,
      FieldsEnum.CheckoutOwnerPesel,
      FormsEnum.CheckoutForm
    );
  },
};

export default ownerCountryOfOrigin;
